import { SizeUnit } from '@utils/types';

import ClientOnlyPortal from './ClientOnlyPortal';
import {
  CloseButton,
  DrawerMask,
  StyledDrawer,
  StyledDrawerBody,
  StyledDrawerHeader,
  StyledDrawerTitle,
  StyledDrawerWrapper,
} from './DrawerStyle';
import { getTransform } from './helpers';

export type DrawerProps = {
  visible: boolean;
  onClose?: () => void;
  width?: SizeUnit;
  height?: SizeUnit;
  title?: React.ReactNode;
  closeIcon?: React.ReactNode;
  placement?: 'top' | 'right' | 'bottom' | 'left';
  footer?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  animation?: 'topToBottom' | 'rightToLeft';
  booker?: boolean;
};

export const DrawerHeader = StyledDrawerHeader;
export const DrawerTitle = StyledDrawerTitle;
export const DrawerBody = StyledDrawerBody;
export const DrawerWrapper = StyledDrawerWrapper;

const Drawer = ({
  visible,
  width,
  height,
  title,
  closeIcon,
  onClose,
  placement = 'top',
  footer,
  className,
  children,
  animation = 'topToBottom',
}: React.PropsWithChildren<DrawerProps>) => {
  return (
    <ClientOnlyPortal selector='body'>
      <DrawerWrapper tabIndex={-1}>
        <DrawerMask visible={visible} onClick={onClose} />
        <StyledDrawer
          visible={visible}
          width={width}
          height={height}
          placement={getTransform(placement)}
          className={className}
          animation={animation}
        >
          <DrawerWrapper>
            <DrawerHeader>
              {closeIcon ? (
                <CloseButton onClick={onClose}>{closeIcon}</CloseButton>
              ) : null}
              {title ? <StyledDrawerTitle>{title}</StyledDrawerTitle> : null}
            </DrawerHeader>
            <DrawerBody>
              {children}
              {footer}
            </DrawerBody>
          </DrawerWrapper>
        </StyledDrawer>
      </DrawerWrapper>
    </ClientOnlyPortal>
  );
};

export default Drawer;
